/* eslint-disable import/prefer-default-export */
export const reducerName = `activatedCouponForm`;
export const createReducerDotPathName = combineName =>
  `${combineName}.${reducerName}`;
export const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/coupons/reducers/activatedCouponForm/naming.js